<div class="m-x-md cipo--height--full">
    @defer {
        <app-data-list-command [(filtersToApply)]="filtersToApply" [filters]="filters()">
            @if (canCreate()) {
                <button mat-flat-button color="primary" (click)="addEditEntry()">
                    <mat-icon>add</mat-icon>
                    {{ "actions.addNew" | translate }}
                </button>
            }
            <!-- For some reason, the generic type is not set properly. The ScheduledEmailRow should be bind instead of TableRow in $event.
         Will investigate a way to get rid of $any()
         It works on dynamic-module-table with the same setup -->
            @if (isInfiniteScroll()) {
                <cipo-infinite-data-list
                    cipoCommandContent
                    [options]="options()"
                    [tableColumns]="tableColumns()"
                    [tableData]="tableData()"
                    [updatedRows]="updatedRows()"
                    primaryKey="id"
                    (rowClicked)="addEditEntry($any($event))"
                    (actionSelected)="performAction($any($event))"
                    (paginationUpdated)="loadScheduledEmails($event.pageIndex)"
                    (sortChanged)="loadScheduledEmails()" />
            } @else {
                <cipo-paged-data-list
                    cipoCommandContent
                    [options]="options()"
                    [tableColumns]="tableColumns()"
                    [tableData]="tableData()"
                    [updatedRows]="updatedRows()"
                    primaryKey="id"
                    (rowClicked)="addEditEntry($any($event))"
                    (actionSelected)="performAction($any($event))"
                    (paginationUpdated)="onPaginationUpdated($event)"
                    (sortChanged)="loadScheduledEmails()" />
            }
        </app-data-list-command>
    }
</div>
